import { ErrorBoundary } from '@gamma/ui/overlay';
import { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { ROUTES } from '../../../shared/constants';
import { AuthContext } from '../../../shared/providers/AuthProvider';

export const Admin = () => {
  const navigate = useNavigate();
  const { user, userRole } = useContext(AuthContext);
  const { home } = ROUTES;

  useEffect(() => {
    if (!user || userRole !== 'admin') {
      navigate(home);
    }
  }, [user, userRole]);

  return (
    <ErrorBoundary page="Admin" styleClass="main">
      <Outlet />
    </ErrorBoundary>
  );
};
